import { Theme, ListProps } from '@mui/material';

declare module '@mui/material/List' {
  interface CustomListProps extends ListProps {
    spacing?: number;
  }
}

export const getListOptions = (theme: Theme) => {
  const listComponents = {
    styleOverrides: {
      root: ({ ownerState }: { ownerState: { spacing: number } }) => {
        return {
          ['&>:not(style):not(style)']: {
            margin: 0,
          },
          ['&>:not(style)~:not(style)']: {
            marginTop: theme.spacing(ownerState.spacing ?? 0),
          },
        };
      },
    },
    defaultProps: {
      disablePadding: true,
    },
  };

  return { listComponents };
};
